import { useTranslation } from 'react-i18next'

import { useGretaAIChatContext } from '../GretaAIChat.hooks'
import { GretaAIChatRowMenu } from '../GretaAIChatRowMenu'

import { QA_NAME_GRETA_AI_CHAT_PROJECT_MENU } from './GretaAIChatProjectMenu.constants'
import { getGretaAIChatProjectMenuItems } from './GretaAIChatProjectMenu.utils'

function GretaAIChatProjectMenu({ className, project }) {
  const { t } = useTranslation()

  const { actions } = useGretaAIChatContext()

  const { onDeleteProject, onRenameProject, onRowMenuOpenChange } = actions

  function handleRename() {
    onRenameProject(project)
  }

  function handleDelete() {
    onDeleteProject(project)
  }

  return (
    <GretaAIChatRowMenu
      className={className}
      items={getGretaAIChatProjectMenuItems({
        t,
        onDelete: handleDelete,
        onRename: handleRename,
      })}
      qaName={QA_NAME_GRETA_AI_CHAT_PROJECT_MENU}
      onOpenChange={onRowMenuOpenChange}
    />
  )
}

export default GretaAIChatProjectMenu
